module.exports = __webpack_public_path__ + "static/img/img2.4c8e454.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/approve/img2.jpg
// module id = eBTK
// module chunks = 1